import { useEffect, useState } from 'react';
import axios from 'axios';
import { Image as ImageIcon } from 'lucide-react';
import { getAuthHeaders } from '../../utils/authHeaders';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const cache = new Map();

/* JWT-protected shared-asset image → object URL (the library has no public links). */
export function useAssetBlob(assetId, version) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!assetId) { setSrc(null); return undefined; }
    const key = `${assetId}:${version || ''}`;
    if (cache.has(key)) { setSrc(cache.get(key)); return undefined; }
    let alive = true;
    axios.get(`${API_URL}/api/admin/shared-assets/${assetId}/image`, { headers: getAuthHeaders(), responseType: 'blob' })
      .then((r) => { const u = URL.createObjectURL(r.data); cache.set(key, u); if (alive) setSrc(u); })
      .catch(() => { if (alive) setSrc(null); });
    return () => { alive = false; };
  }, [assetId, version]);
  return src;
}

export function AssetThumb({ assetId, version, className = 'w-10 h-10', alt = '' }) {
  const src = useAssetBlob(assetId, version);
  return (
    <div className={`${className} rounded-lg bg-[#050505] border border-white/10 flex items-center justify-center overflow-hidden shrink-0`} data-testid={`asset-thumb-${assetId || 'none'}`}>
      {src ? <img src={src} alt={alt} className="max-w-full max-h-full object-contain p-0.5" /> : <ImageIcon className="w-4 h-4 text-white/20" />}
    </div>
  );
}
